import { mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"
import DynamicNode from "../Dynamic.js"

export default DynamicNode({
  name: 'AlgoliaCategory',

  group: 'block',

  atomic: true,

  draggable: true,

  marks: '',

  renderHTML({ HTMLAttributes }) {
    return [this.options.schema.tag, mergeAttributes(HTMLAttributes)]
  },
}, View)
